import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 DÍAS DE LA SEMANA

    Días sueltos, sin horarios. Para recordatorios, frecuencia de envío
    o disponibilidad. Distinto de FieldSchedule: eso maneja tramos, esto
    solo marca qué días sí.

    Los atajos ahorran los tres casos más comunes.
*/

export const WEEKDAYS = [
    { id: 'mon', label: 'Lunes', short: 'L' },
    { id: 'tue', label: 'Martes', short: 'M' },
    { id: 'wed', label: 'Miércoles', short: 'M' },
    { id: 'thu', label: 'Jueves', short: 'J' },
    { id: 'fri', label: 'Viernes', short: 'V' },
    { id: 'sat', label: 'Sábado', short: 'S' },
    { id: 'sun', label: 'Domingo', short: 'D' },
];

const PRESETS = [
    { id: 'week', label: 'Semana', days: ['mon', 'tue', 'wed', 'thu', 'fri'] },
    { id: 'weekend', label: 'Fin de semana', days: ['sat', 'sun'] },
    { id: 'all', label: 'Todos', days: WEEKDAYS.map((d) => d.id) },
];

export const FieldWeekdays = ({
    id, label, hint, error,
    value = [], onChange, showPresets = true,
    isDisabled = false, span = 2,
}) => {

    const onToggle = (dayId) => onChange?.(
        value.includes(dayId) ? value.filter((d) => d !== dayId) : [...value, dayId],
    );

    const onPreset = (days) => {
        const IS_SAME = days.length === value.length && days.every((d) => value.includes(d));
        onChange?.(IS_SAME ? [] : days);
    };

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled}
            hint={hint ?? `${value.length} de 7 días`} >

            <div className={`${BLOCK}__weekdays`}>
                {
                    WEEKDAYS.map((day) => (
                        <button key={day.id} type="button" title={day.label}
                            className={`${BLOCK}__weekday`} data-on={value.includes(day.id)}
                            aria-pressed={value.includes(day.id)} disabled={isDisabled}
                            onClick={() => onToggle(day.id)} >
                            {day.short}
                        </button>
                    ))
                }
            </div>

            {
                showPresets && (
                    <div className={`${BLOCK}__weekdays_presets`}>
                        {
                            PRESETS.map((preset) => (
                                <button key={preset.id} type="button" disabled={isDisabled}
                                    onClick={() => onPreset(preset.days)} >
                                    {preset.label}
                                </button>
                            ))
                        }
                    </div>
                )
            }

        </FieldShell>
    );
};
